exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-63900228] {\n    flex: 0 0 calc(100% / 12);\n    max-width: calc(100% / 12);\n    width: 1.5rem;\n    height: 1.5rem;\n}\n.icon img[data-v-63900228] {\n    max-width: 100%;\n    max-height: 100%;\n    height: auto;\n}\n", ""]);

// exports
